/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const confirmationParamSelector = (state) => state?.confirmationParam;
const confirmationParamSlice = createSlice({
  name: 'confirmationParam',
  initialState: {
    value: {}
  },
  reducers: {
    saveConfirmationParam: (state, action) => {
      state.value = action.payload;
    }
  }
});

// Export actions
export const { saveConfirmationParam } = confirmationParamSlice.actions;

// Export reducer
export default confirmationParamSlice.reducer;
